var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('div',{staticClass:"text-md-center"},[_c('h1',{staticClass:"text-center"},[_vm._v("401")]),_c('h2',{staticClass:"my-3 headline"},[_vm._v("Sinto muito, você não está autorizado.")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }